import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa0d60f4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=aa0d60f4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa0d60f4')) {
      api.createRecord('aa0d60f4', component.options)
    } else {
      api.reload('aa0d60f4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aa0d60f4&", function () {
      api.rerender('aa0d60f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/smartForm/Statement/index.vue"
export default component.exports